import { features } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Features() {
  return (
    <section id="features" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4">
        <SectionHeading
          eyebrow="平台特色"
          title="为什么大家都在用星辰影院"
          desc="除了找得到入口，观影体验本身也很重要。下面是用户最常提到的几个特点，也是长期使用后留下来的理由。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((item) => (
            <article
              key={item.id}
              className="group rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 items-center gap-6 rounded-lg border border-background-200 bg-background-50 p-5 md:grid-cols-12 md:p-6">
          <div className="md:col-span-5">
            <div className="h-56 w-full overflow-hidden rounded-md md:h-64">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20minimal%20flat%20lay%20of%20popcorn%20bucket%2C%20film%20clapperboard%20and%20golden%20tickets%20on%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20amber%20and%20cream%20palette&width=1000&height=800&seq=cinema-feature-02&orientation=squarish"
                alt="爆米花、场记板与电影票组成的观影主题静物"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
          <div className="md:col-span-7">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              一个好用的观影入口，应该具备什么
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              稳定、清晰、找片快，是大多数用户最在意的三点。星辰影院把入口导航、清晰度切换与分类筛选做得足够顺手，
              让你把注意力放回内容本身，而不是折腾地址和设置。
            </p>
            <div className="mt-5 grid grid-cols-3 gap-3">
              <div className="rounded-md bg-background-100 p-3 text-center">
                <div className="font-heading text-xl font-bold text-accent-600">多端</div>
                <div className="mt-1 text-xs text-foreground-500">全平台覆盖</div>
              </div>
              <div className="rounded-md bg-background-100 p-3 text-center">
                <div className="font-heading text-xl font-bold text-accent-600">4K</div>
                <div className="mt-1 text-xs text-foreground-500">支持高清画质</div>
              </div>
              <div className="rounded-md bg-background-100 p-3 text-center">
                <div className="font-heading text-xl font-bold text-accent-600">免注册</div>
                <div className="mt-1 text-xs text-foreground-500">直接浏览</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}